<template>
    <div>
        <el-form :inline="true" :model="form" @keyup.enter.prevent="request">
            <el-form-item>
                <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="request"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="request">搜索</el-button>
            </el-form-item>
        </el-form>

    <div>
        <!-- 根据组获取组人员 -->
        <el-table :data="tableData" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="用户名" prop="internalUserid"></el-table-column>
            <el-table-column label="工号" prop="employeeNo"></el-table-column>
            <el-table-column label="真实姓名" prop="name"></el-table-column>
            <el-table-column label="邮箱" prop="email"></el-table-column>
            <el-table-column label="部门" prop="departmentName"></el-table-column>
            <el-table-column label="组" prop="groupName"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="form.pageIndex"
                       :page-sizes="[10,20]"
                       :page-size="form.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

    </div>
    <div style="margin:70px 0 10px 0;display: flex;">
        <el-button type="primary"  @click="submit" :disabled="submitBtn">确定</el-button>
        <el-button type="default"  @click="onCancel">取消</el-button>
    </div>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    export default {
        props:{
            id:String,
            callback:Function,
            currentHandler:String,
            exceptMe:Boolean,
        },
        data() {
            return {
                tableData:[],
                loading:true,
                multipleSelection: [],
                submitBtn:true,
                form:{
                    pageIndex:1,
                    pageSize:10,
                    keyword:""
                },
                total:null,
            }
        },
        created() {
            this.request();
        },
        methods: {
            request(){
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                let params={
                    ...this.form,
                    groupId:this.id
                }
                services.getUserListByDepartment(params).then(res => {
                    let currentHandler=this.currentHandler
                    // console.log(currentHandler);
                    // console.log(this.exceptMe);
                    let ind
                    if(res.list&&this.exceptMe){
                        res.list.forEach((item,index)=>{
                            console.log(item);
                            if(item.name==currentHandler){
                                console.log(index);
                                ind=index
                            }
                        })
                    }
                    console.log(ind);
                    if(ind||ind==0){
                        res.list.splice(ind,1)
                        res.total--
                    }
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 选择请求人
            handleSelectionChange(val){
                if(val.length > 1){
                    this.submitBtn = true;
                    this.$message.error("只可选择一个请求人")
                }else{
                    this.multipleSelection = val;
                    this.submitBtn = false;
                }
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个请求人")
                }else{
                    this.callback(this.multipleSelection[0]);
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
